import { render, staticRenderFns } from "./verification_list.vue?vue&type=template&id=3a7994b4&scoped=true"
import script from "./verification_list.vue?vue&type=script&lang=js"
export * from "./verification_list.vue?vue&type=script&lang=js"
import style0 from "./verification_list.vue?vue&type=style&index=0&id=3a7994b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7994b4",
  null
  
)

export default component.exports